import type { RouteLocationNormalized, RouteLocationRaw } from 'vue-router';

// Where a denied navigation lands. Denials normally go to `home`, but `home`
// itself is guarded (LIST_VISITS + ALLOW_CALENDAR — a START package has no
// calendar), and vue-router's same-location loop detector is dev-only, so
// bouncing a denied `home` back to `home` would spin forever in production.
// The chain therefore walks the bottom-nav order and ends on `profile`, the
// one deliberately unguarded tab, so it always terminates:
//   anything → home → patients → profile
export const deniedRedirect = (
  to: RouteLocationNormalized
): RouteLocationRaw => {
  if (to.name === 'home') return { name: 'patients' };
  if (to.name === 'patients') return { name: 'profile' };
  return { name: 'home' };
};
